export default function authHeader() {
    const user = JSON.parse(localStorage.getItem('user'));

    if (user && user.accessToken) {
        //console.log('auth-header : Bearer : ' + user.accessToken);
        return {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
            "Content-type": "application/json",
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + user.accessToken
        };

    } else {
        //console.log('auth-header encours ' );
        return {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
            "Content-type": "application/json",
            'Accept': 'application/json',
            'Authorization': ''
        };
    }
}
